<hr>
<div class="row">
  <aero-form submitButtonLabel='Run Migrator'
    [showCancelButton]="false"
    (onSubmit)="runMigrators($event)">
    <aero-input [type]="'text'"
          [label]="'Run Migrator'"
          [name]="'runMigratorName'"
          [placeholder]="'Migrator Name or default'"
          [required]="true"
          [(ngModel)]="runMigratorName"
          [maxlength]="100">
    </aero-input>
  </aero-form>
  <div *ngIf="runMigratorResponse" class="medium-12 columns">
    <pre>
      <div>{{runMigratorResponse | json}}</div>
    </pre>
  </div>
  <hr>
  <aero-form submitButtonLabel='Get Migrator Status'
    [showCancelButton]="false"
    (onSubmit)="getMigratorStatus($event)">
    <aero-input [type]="'text'"
      [label]="'Migrator Status'"
      [name]="'migratorStatusName'"
      [placeholder]="'Migrator Name or default'"
      [required]="true"
      [(ngModel)]="migratorStatusName"
      [maxlength]="80">
    </aero-input>
  </aero-form>
  <div *ngIf="migratorStatuses.length > 0" class="medium-12 columns">
    <div *ngFor="let migratorStatus of migratorStatuses">
      {{ migratorStatus | json }}
    </div>
  </div>
</div>
